// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-Umy3W5"};